var map = {
	"./CasinoLogin": "liph",
	"./CasinoLogin.vue": "liph",
	"./CasinoLoginRestriction": "rYFh",
	"./CasinoLoginRestriction.vue": "rYFh",
	"./ChangePassword": "DoU/",
	"./ChangePassword.vue": "DoU/",
	"./Error": "EZN1",
	"./Error.vue": "EZN1",
	"./Games": "VOJf",
	"./Games.vue": "VOJf",
	"./Play": "QOP1",
	"./Play.vue": "QOP1",
	"./Withdrawal": "OAdO",
	"./Withdrawal.vue": "OAdO"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "U242";